import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-duration',
    templateUrl: './duration.component.html',
    styleUrls: ['./duration.component.scss'],
    standalone: false,
})
export class DurationComponent implements OnInit {
    @Input() duration;
    @Output() updatedDuration = new EventEmitter();
    @Output() changeStatus = new EventEmitter<boolean>();
    durationExpiry = 0;
    _days = 0;
    _hours = 0;
    _minutes = 0;
    _seconds = 0;
    private isExpireDurationChange = false;
    private previousDuration: number;
    isUserInteracting = false;

    onUserInteraction() {
        this.isUserInteracting = true;
    }

    get days(): number {
        return this._days;
    }

    set days(v) {
        this._days = v;
        this._cdr.detectChanges();
        if (v > this.config.max.days) {
            v = this.config.max.days;
        } else if (v < 0) {
            v = 0;
        }
        this._days = v;
        this.durationChanged();
    }

    get hours(): number {
        return this._hours;
    }

    set hours(v) {
        this._hours = v;
        this._cdr.detectChanges();
        if (v > this.config.max.hours) {
            v = this.config.max.hours;
        } else if (v < 0) {
            v = 0;
        }
        this._hours = v;
        this.durationChanged();
    }

    get minutes(): number {
        return this._minutes;
    }

    set minutes(v) {
        this._minutes = v;
        this._cdr.detectChanges();
        if (v > this.config.max.minutes) {
            v = this.config.max.minutes;
        } else if (v < 0) {
            v = 0;
        }
        this._minutes = v;
        this.durationChanged();
    }

    get seconds(): number {
        return this._seconds;
    }

    set seconds(v) {
        this._seconds = v;
        this._cdr.detectChanges();
        if (v > this.config.max.seconds) {
            v = this.config.max.seconds;
        } else if (v < 0) {
            v = 0;
        }
        this._seconds = v;
        this.durationChanged();
    }

    config: any = {
        labels: {
            days: 'D',
            hours: 'H',
            minutes: 'M',
            seconds: 'S',
        },
        max: {
            days: 29,
            hours: 23,
            minutes: 59,
            seconds: 59,
        },
    };

    constructor(private _cdr: ChangeDetectorRef) {}

    durationChanged = () => {
        this.durationExpiry = 0;
        this.durationExpiry = this.durationExpiry + this.days * 60 * 60 * 24;
        this.durationExpiry = this.durationExpiry + this.hours * 60 * 60;
        this.durationExpiry = this.durationExpiry + this.minutes * 60;
        this.durationExpiry = this.durationExpiry + this.seconds;
        this.updatedDuration.emit(this.durationExpiry);
    };

    incrementOrDecrement = (value: string, durationFor: string) => {
        this.onUserInteraction();
        switch (durationFor) {
            case 'D':
                if (value === 'INCREMENT') {
                    this.days = this.days + 1;
                } else {
                    this.days = this.days - 1;
                }
                break;
            case 'H':
                if (value === 'INCREMENT') {
                    this.hours = this.hours + 1;
                } else {
                    this.hours = this.hours - 1;
                }
                break;
            case 'M':
                if (value === 'INCREMENT') {
                    this.minutes = this.minutes + 1;
                } else {
                    this.minutes = this.minutes - 1;
                }
                break;
            default:
                if (value === 'INCREMENT') {
                    this.seconds = this.seconds + 1;
                } else {
                    this.seconds = this.seconds - 1;
                }
                break;
        }
    };

    checkAndEmitChange() {
        if (this.durationExpiry !== this.previousDuration) {
            this.isExpireDurationChange = true;
            if (this.isUserInteracting) {
                this.changeStatus.emit(this.isExpireDurationChange);
            }
            this.previousDuration = this.durationExpiry;
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.duration) {
            const durationObj: any = this.convertSecondsToDurationSlabs(this.duration);
            this.days = durationObj.days;
            this.hours = durationObj.hours;
            this.minutes = durationObj.minutes;
            this.seconds = durationObj.seconds;
        }
        this.checkAndEmitChange();
        this.isUserInteracting = false;
    }

    convertSecondsToDurationSlabs = sec => {
        const days = Math.floor(sec / (24 * 60 * 60));
        const daysSec = sec % (24 * 60 * 60);
        const hours = Math.floor(daysSec / (60 * 60));
        const hoursSec = sec % (60 * 60);
        const minutes = Math.floor(hoursSec / 60);
        const minutesSec = sec % 60;
        const seconds = Math.floor(minutesSec);
        return { days, hours, minutes, seconds };
    };

    ngOnInit() {
        this.previousDuration = this.duration;
    }
}
